/* eslint-disable react/no-danger */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-key */
import React, { useState, useEffect } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import katex from "katex";
import "katex/dist/katex.min.css";
import { ListItemText, Grid, FormControl, FormHelperText, Typography, FormGroup, Radio, RadioGroup, Link, Tooltip, InputLabel, IconButton } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
// import ImageResize from 'quill-image-resize-module-react';
import Checkbox from '@mui/material/Checkbox';
import { Form, Formik, FieldArray } from 'formik';
import Autocomplete from '@mui/material/Autocomplete';
import * as Yup from 'yup';
import { makeStyles } from '@mui/styles';
import AppleIcon from '@mui/icons-material/Apple';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { LoadingButton } from '@mui/lab';
import ClearIcon from '@mui/icons-material/Clear';
import DialogModal from '../../../components/modal/DialogModal';
import ErrorFocus from '../../../components/ErrorFocus/ErrorFocus';
import WindowsIcon from '../../../assets/logo/windows.svg';
import adminServices from '../../../services/adminServices';
import './styles.css';
import QuillEditor from '../../../components/Quill/Quill'
// Quill.register('modules/imageResize', ImageResize);
// Quill.register('modules/imageResize', ImageResize);


window.katex = katex;

const Parchment = Quill.import("parchment");

const Style = new Parchment.Attributor.Style("style", "style");
Quill.register(Style, true);

const ImageWidth = new Parchment.Attributor.Attribute("width", "width", {
    scope: Parchment.Scope.INLINE,
});
Quill.register(ImageWidth, true);

const ImageHeight = new Parchment.Attributor.Attribute("height", "height", {
    scope: Parchment.Scope.INLINE,
});
Quill.register(ImageHeight, true);


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
    },
}));

window.katex = katex;

// const modules = {
//     toolbar: [
//         ["bold", "italic", "underline"], // toggled buttons
//         // ["blockquote"],
//         [{ list: "ordered" }, { list: "bullet" }],
//         [{ script: "sub" }, { script: "super" }], // superscript/subscript
//         [{ header: [1, 2, 3, false] }],
//         ["image", { formula: { customClass: 'qlformula' } }],
//         [{ color: [] }, { background: [] }], // dropdown with defaults from theme
//         [{ align: [] }],
//         ["clean"], // remove formatting button
//     ],
//     clipboard: {
//         matchVisual: false,
//     },
//     imageResize: {
//         parchment: Quill.import('parchment'),
//         modules: ['Resize', 'DisplaySize', 'Toolbar']
//     },
// };




function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const CreateMcqQuestionModel = ({ open, modelClose, title, handleCreateMcq, loading, searchedDetails }) => {
    const quillRefs = {
        question: React.useRef(null),
        explanation: React.useRef(null),
        mcqOptions: React.useRef([])
    };
    const [passageList, setPassageList] = useState([]);
    const [passage, setPassage] = useState('');



    const [combinedWKeys, setCombinedWKeys] = useState([]);
    const [combinedWKeyName, setCombinedWKeyName] = useState([]);
    const [combinedMKeys, setCombinedMKeys] = useState([]);
    const [combinedMKeyName, setCombinedMKeyName] = useState([]);
    const [widowKeys, setWidowKeys] = useState([]);
    const [macKeys, setMacKeys] = useState([]);
    const [useWindowVirtualKeys, setUseWindowVirtualKeys] = useState(false);
    const [useMacVirtualKeys, setUseMacVirtualKeys] = useState(false);
    const [category, setCategory] = useState([]);
    const [keyword, setKeyWord] = useState([]);
    const [subModule, setSubModule] = useState([]);
    const [passageError, setPassageError] = useState([]);
    const [numericError, setNumericError] = useState('');

    const [submitError, setSubmitError] = useState('');
    const [currectError, setCurrectError] = useState('')
    const [numericvalue, setNumericAnswer] = useState('')
    const [assessmenttype, setAssessmentType] = useState('CLATPASSAGE');

    const [initialValues, setInitialValues] = useState({
        question: '',
        questionType: '',
        mcqOptions: [],
        level: '',
        studyMaterials: [],
        points: null,
        windowsKey: '',
        keyType: '',
        macKey: '',
        combinedWindowKeys: [],
        combinedMacKeys: [],
        combinedWindowKeyName: [],
        combinedMacKeyName: [],
        course: null,
        module: '',
        subModule: '',
        courseCategory: null,
        tag: '',
        keyword: [],
        selectedSkills: "",
        explanation: ''
    });

    useEffect(() => {
        setPassage('');
        setNumericAnswer('');
        setCombinedWKeys([]);
        setCombinedMKeys([]);
        setCombinedWKeyName([]);
        setCombinedMKeyName([]);
        getKeyboardLookUp();
    }, [open]);

    const handleFiles = async (files, targetRef) => {
        const quillInstance = targetRef?.current?.getEditor();
        if (!quillInstance) return;

        for (const file of files) {
            if (file.type.startsWith("image/")) {
                const range = quillInstance.getSelection(true);
                const tempId = `temp-${Date.now()}`;
                quillInstance.insertEmbed(range.index, "image", `/loading.gif?${tempId}`);
                quillInstance.setSelection(range.index + 1);

                const url = await handleUploadImage(file);
                if (url) {
                    const editorEl = quillInstance.root;
                    const imgEl = editorEl?.querySelector(`img[src="/loading.gif?${tempId}"]`);
                    if (imgEl) imgEl.setAttribute("src", url);
                }
            }
        }
    };

    React.useEffect(() => {
        const mountedRefs = Object.values(quillRefs).filter(ref => ref?.current);
        if (!mountedRefs.length) return;

        mountedRefs.forEach((ref) => {
            const editor = ref.current.root;
            if (!editor) return;

            const pasteHandler = (e) => {
                const items = e.clipboardData?.items;
                if (items) {
                    const files = [];
                    for (const item of items) {
                        if (item.type.indexOf("image") !== -1) {
                            e.preventDefault();
                            files.push(item.getAsFile());
                        }
                    }
                    if (files.length) handleFiles(files, ref);
                }
            };

            const dropHandler = (e) => {
                e.preventDefault();
                const files = e.dataTransfer?.files;
                if (files?.length) handleFiles(files, ref);
            };

            editor.addEventListener("paste", pasteHandler);
            editor.addEventListener("drop", dropHandler);
            editor.addEventListener("dragover", (e) => e.preventDefault());

            return () => {
                editor.removeEventListener("paste", pasteHandler);
                editor.removeEventListener("drop", dropHandler);
            };
        });
    }, [quillRefs.question.current, quillRefs.explanation.current]);

    const handleUploadImage = async (file) => {
        const formData = new FormData();
        formData.append("thumbImage", file);
        try {
            const imageUrl = await adminServices.postImag(formData);
            if (imageUrl?.ok) {
                return imageUrl.data;
            }
        } catch (error) {
            console.error("Image upload failed", error);
        }
        return null;
    };

    const imageHandler = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.click();

        input.onchange = () => {
            if (input.files?.length) {
                handleFiles(input.files);
            }
        };
    };




    const getModules = (targetRef) => ({
        toolbar: {
            container: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ script: "sub" }, { script: "super" }],
                [{ header: [1, 2, 3, false] }],
                // ["image"],
                ["image", { formula: { customClass: 'qlformula' } }],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                ["clean"],
            ],
            handlers: {
                image: () => {
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = "image/*";
                    input.click();

                    input.onchange = () => {
                        if (input.files?.length) {
                            handleFiles(input.files, targetRef);
                        }
                    };
                },
            },
        },
        clipboard: { matchVisual: false },
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize', 'Toolbar']
        },
    });


    const formats = React.useMemo(() => [
        "bold", "italic", "underline",
        "list", "bullet",
        "script",
        "header",
        "image",
        "formula",
        "color", "background",
        "align", "style", "width", "height"
    ], []);


    useEffect(() => {
        getPassageList(assessmenttype);
    }, [assessmenttype])

    const getPassageList = async (type) => {
        const search = ''
        try {
            const result = await adminServices.getPassage(0, 1000, type, search);
            if (result.ok) {
                setPassageList(result.data.data);
            }
        } catch (error) {
            console.log("Error getting passages:", error);
        }
    }




    const getKeyboardLookUp = async () => {
        const lookUpResponse = await adminServices.getLookUpData('keyboard_keys');
        if (lookUpResponse.ok) {
            // setWidowKeys();
            const windowArray = lookUpResponse.data.keyboard_keys.filter((a, b) => a.keyboard === 'WINDOWS');
            const macArray = lookUpResponse.data.keyboard_keys.filter((a, b) => a.keyboard !== 'WINDOWS');
            setWidowKeys(windowArray);
            setMacKeys(macArray);
        }
    };

    const validationSchema = Yup.object().shape({
        question: Yup.string().required('Question is required'),
        level: Yup.string().required('Level is required'),
        selectedSkills: Yup.string().required('selectedSkills is required'),
        questionType: Yup.string().required('Question type is required'),
        explanation: Yup.string().when('questionType', {
            // is: (value) => value !== 'IQ',
            is: (value) => value !== 'IQ',
            then: Yup.string().required('Explanation is required'),
            otherwise: Yup.string().nullable(),
        }),
        mcqOptions: Yup.array().of(
            Yup.object().shape({
                option: Yup.string().required('Option field is required'),
                isCorrect: Yup.boolean(),
            })
        ).when('questionType', {
            is: (value) => value !== 'IQ',
            then: Yup.array().min(1, 'At least one option is required'),
            otherwise: Yup.array().nullable(),
        }),
        keyType: Yup.string().when('questionType', {
            is: 'IQ',
            then: Yup.string().required('Key Type is required for IQ questions'),
            otherwise: Yup.string().nullable(),
        }),

    });

    const getLookUpDetails = async () => {
        const key = ['course', 'course_category', 'hashtag'];
        const result = await adminServices.getLookUpData(key);
        if (result.ok) {
            setCategory(result.data.course_category);
            setKeyWord(result.data.hashtag);
        }
    };
    useEffect(() => {
        getLookUpDetails()
    }, [])

    const classes = useStyles();
    const questionModules = React.useMemo(() => getModules(quillRefs.question), []);
    const explanationModules = React.useMemo(() => getModules(quillRefs.explanation), []);



    const updateMcqRefs = React.useCallback((optionsLength) => {

        while (quillRefs.mcqOptions.current.length < optionsLength) {
            quillRefs.mcqOptions.current.push(React.createRef());
        }

    }, []);


    const stableMcqModule = React.useMemo(() => ({
        toolbar: {
            container: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ script: "sub" }, { script: "super" }],
                [{ header: [1, 2, 3, false] }],
                ["image", { formula: { customClass: 'qlformula' } }],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                ["clean"],
            ],
            handlers: {
                image: () => {
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = "image/*";
                    input.click();

                    input.onchange = () => {
                        if (input.files?.length) {

                            const activeElement = document.activeElement;
                            const quillContainer = activeElement.closest('.ql-container');
                            if (quillContainer) {
                                const quillInstance = quillContainer.__quill;
                                if (quillInstance) {
                                    handleFiles(input.files, { current: { getEditor: () => quillInstance } });
                                }
                            }
                        }
                    };
                },
            },
        },
        clipboard: { matchVisual: false },
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize', 'Toolbar']
        },
    }), []);

    const getMcqModulesArray = React.useCallback((optionsLength) => {
        updateMcqRefs(optionsLength);
        return Array(optionsLength).fill(stableMcqModule);
    }, [updateMcqRefs, stableMcqModule]);


    React.useEffect(() => {
        if (!quillRefs.mcqOptions.current) {
            quillRefs.mcqOptions.current = [];
        }
    }, []);

    return (
        <DialogModal open={open} handleClose={modelClose} title={title}>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    
                    setSubmitError('');
                    setPassageError('')
                    setCurrectError('');
                    setNumericError('')

                    const hasAtLeastOneCorrect = values.mcqOptions?.some(option => option.isCorrect);
                    if (values.questionType === "MCQ" || values.questionType === "JEEMCQ1" || values.questionType === "JEEMCQ2" || values.questionType === "JEEPassage" || values.questionType === "ClatPassage" || values.questionType === "screenLevelMcq" || values.questionType === 'Chemistry' || values.questionType === 'Physics' || values.questionType === 'Biology') {
                        const isEditorContentEmpty = (html) => {
                            if (!html) return true;
                            const text = html?.replace(/<(.|\n)*?>/g, '').trim();
                            if (text) return false;
                            const hasImage = /<img\s[^>]*src="[^"]*"[^>]*>/i.test(html);
                            return !hasImage;
                        };
                        if (isEditorContentEmpty(values.question)) {
                            setSubmitError('Question is required');
                            return;
                        }
                        if (values.mcqOptions.length <= 3) {
                            setSubmitError('You must provide at least 4 options.');
                            return;
                        }
                        if (hasAtLeastOneCorrect === false) {
                            setCurrectError("You must select at least one correct answer")
                            return;
                        }
                        if ((values.questionType === "JEEPassage" || values.questionType === "ClatPassage") && passage === '') {
                            setPassageError("Passage is Required!")
                            return;
                        }

                    }

                    if (values.questionType === "JEENumeric") {
                        const isEditorContentEmpty = (html) => {
                            if (!html) return true;
                            const text = html?.replace(/<(.|\n)*?>/g, '').trim();
                            if (text) return false;
                            const hasImage = /<img\s[^>]*src="[^"]*"[^>]*>/i.test(html);
                            return !hasImage;
                        };
                        if (isEditorContentEmpty(values.question)) {

                            setSubmitError('Question is required');
                            return;
                        }
                        if (!numericvalue) {
                            setNumericError("This field is Required!")
                            return;
                        }

                    }

                    const transformedValues = {
                        ...values,
                        passage: passage || '',
                        numericanswer: numericvalue,
                        mcqOptions: values.mcqOptions.map(opt => ({
                            ...opt,
                            isCorrect: opt.isCorrect === true,
                        })),
                    };
                    handleCreateMcq(transformedValues);
                    ;

                }}
            >
                {({ values, touched, errors, handleBlur, handleChange, setFieldValue, isSubmitting }) => {

                    const mcqModulesArray = React.useMemo(() => {
                        return getMcqModulesArray(values.mcqOptions.length);
                    }, [values.mcqOptions.length, getMcqModulesArray]);

                    const prevOptionsLengthRef = React.useRef(values.mcqOptions.length);

                    React.useEffect(() => {
                        prevOptionsLengthRef.current = values.mcqOptions.length;
                    }, [values.mcqOptions.length]);

                    

                    return (
                        <Form>

                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl className={classes.formControl} error={touched.points && Boolean(errors.points)}>
                                        <Autocomplete
                                            id="CourseCategory"
                                            fullWidth
                                            filterSelectedOptions
                                            autoComplete
                                            options={category}
                                            autoHighlight
                                            getOptionLabel={(option) => option.description}
                                            value={category.find(cat => cat.code === values.courseCategory) || null}
                                            onChange={(e, value) => {
                                                const codeValue = value ? value.code : null;
                                                setFieldValue('courseCategory', codeValue);
                                            }}
                                            getOptionSelected={(option, value) => option.code === value}
                                            renderOption={(props, option) => (
                                                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                                    <img loading="lazy" width="20" src={option.categoryImgUrl} alt="i" />
                                                    {option.description}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name="courseCategory"
                                                    error={Boolean(touched.courseCategory && errors.courseCategory)}
                                                    helperText={touched.courseCategory && errors.courseCategory}
                                                    label="Question category"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl className={classes.formControl} error={touched.points && Boolean(errors.points)}>
                                        <Autocomplete
                                            id="studyMaterials"
                                            fullWidth
                                            filterSelectedOptions
                                            autoComplete
                                            multiple
                                            options={keyword}
                                            autoHighlight
                                            getOptionLabel={(option) => option.description}
                                            value={
                                                values.keyword
                                                    ? keyword.filter(cat => values.keyword.includes(cat.code))
                                                    : []
                                            }
                                            onChange={(e, value) => {
                                                const selectedCodes = value ? value.map(item => item.code) : [];
                                                setFieldValue('keyword', selectedCodes);
                                            }}
                                            renderOption={(props, option) => (
                                                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                                    {option.description}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name="keyword"
                                                    error={Boolean(touched.keyword && errors.keyword)}
                                                    helperText={touched.keyword && errors.keyword}
                                                    label="Tag"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl className={classes.formControl} error={touched.questionType && Boolean(errors.questionType)}>
                                        <InputLabel id="demo-simple-select-standard-label">Level*</InputLabel>
                                        <Select
                                            name="level"
                                            labelId="demo-simple-select-standard-label"
                                            id="level"
                                            label="Level"
                                            value={values.level}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            displayEmpty
                                        >
                                            <MenuItem value="easy">Easy</MenuItem>
                                            <MenuItem value="medium">Medium</MenuItem>
                                            <MenuItem value="complex">Complex</MenuItem>
                                        </Select>
                                        {touched.level && errors.level && (
                                            <FormHelperText>{errors.level}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl className={classes.formControl} style={{ width: "100%" }}>
                                        <Autocomplete
                                            multiple
                                            id="studyMaterials"
                                            name="studyMaterials"
                                            options={[
                                                'Previous year questions',
                                                'Practice questions',
                                                'Exampler questions',
                                            ]}
                                            value={values.studyMaterials}
                                            onChange={(event, newValue) => {
                                                setFieldValue('studyMaterials', newValue);
                                            }}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Study Materials"
                                                    placeholder="Select"
                                                    error={touched.studyMaterials && Boolean(errors.studyMaterials)}
                                                    helperText={touched.studyMaterials && errors.studyMaterials}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>


                                <Grid item xs={4}>
                                    <FormControl className={classes.formControl} error={touched.questionType && Boolean(errors.questionType)}>
                                        <InputLabel id="demo-simple-select-standard-label">Question Type*</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="questionType"
                                            name="questionType"
                                            label="Question Type"
                                            value={values.questionType}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                setFieldValue('questionType', e.target.value)
                                                if (e.target.value === 'IQ') {
                                                    setFieldValue("mcqOptions", [])
                                                    setFieldValue("question", '')
                                                } else if (e.target.value === 'MCQ' || "JEEMCQ1" || "JEEMCQ2") {
                                                    setFieldValue("keyType", '')
                                                    // setFieldValue("question", '')
                                                    setFieldValue("windowsKey", '')
                                                    setFieldValue("macKey", '')
                                                    // setFieldValue("combinedWindowKeys",[])
                                                    // setFieldValue("combinedMacKeys",[])
                                                    // setFieldValue("combinedWindowKeyName",[])
                                                    // setFieldValue("combinedMacKeyName",[])
                                                }
                                                setPassage('')
                                                setAssessmentType(e.target.value);
                                            }}
                                            displayEmpty
                                        >
                                            <MenuItem value="MCQ">MCQ Question</MenuItem>
                                            <MenuItem value="IQ">IQ Question</MenuItem>
                                            <MenuItem value="screenLevelMcq">screenLevelMcq</MenuItem>
                                            <MenuItem value="Chemistry">Chemistry</MenuItem>
                                            <MenuItem value="Physics">Physics</MenuItem>
                                            <MenuItem value="Biology">Biology</MenuItem>
                                            <MenuItem value="JEEMCQ1">JEE MCQ1</MenuItem>
                                            <MenuItem value="JEEMCQ2">JEE MCQ2</MenuItem>
                                            <MenuItem value="JEEPassage">JEE Passage</MenuItem>
                                            <MenuItem value="JEENumeric">JEE Numeric</MenuItem>
                                            <MenuItem value="ClatPassage">CLAT Passage</MenuItem>



                                        </Select>
                                        {touched.questionType && errors.questionType && (
                                            <FormHelperText>{errors.questionType}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl className={classes.formControl} error={touched.points && Boolean(errors.points)}>
                                        <TextField
                                            name="points"
                                            type="number"
                                            id="points"
                                            label="Points"
                                            variant="outlined"
                                            value={values.points}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            InputProps={{ inputProps: { min: 0 } }}
                                            onKeyDown={(e) => {
                                                if (e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && (e.key < '0' || e.key > '9')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                        {touched.points && errors.points && (
                                            <FormHelperText>{errors.points}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item>
                                    <FormControl fullWidth variant="outlined">

                                        <Typography style={{ marginBottom: '0px' }} color="primary" className={classes.background} gutterBottom variant="subtitle1">
                                            Select Level of Objective *                                               </Typography>

                                        <FormGroup className="FormCheck">
                                            {['Knowledge', 'Comprehension', 'Application', 'Analysis', 'Synthesis', 'Evaluation'].map((skill) => (
                                                <FormControlLabel
                                                    key={skill}
                                                    control={
                                                        <Radio
                                                            id={`createquestionselect${skill}`}
                                                            checked={values.selectedSkills === skill}
                                                            value={skill}
                                                            onChange={(e) => setFieldValue('selectedSkills', e.target.value)}
                                                        />
                                                    }
                                                    label={skill}
                                                />
                                            ))}
                                        </FormGroup>
                                        {touched.selectedSkills && errors.selectedSkills && (
                                            <FormHelperText style={{ color: "#FF4842" }}>{errors.selectedSkills}</FormHelperText>
                                        )}
                                    </FormControl>

                                </Grid>
                                {(values?.questionType === "JEEPassage" || values?.questionType === "ClatPassage") &&
                                    <Grid item xs={12} sm={12} sx={{ marginBottom: '15px', paddingRight: '18px' }}>
                                        <InputLabel id="passage-label">Passage *</InputLabel>
                                        <Select
                                            name="passage"
                                            labelId="passage-label"
                                            id="passage"
                                            value={passage}
                                            onChange={(e) => {
                                                setPassage(e.target.value);
                                                setPassageError('');
                                            }}
                                            renderValue={(selected) => (
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: selected?.passage_text || '' }}
                                                    style={{
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        maxWidth: '500px'
                                                    }}
                                                />
                                            )}
                                            MenuProps={{
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 280,
                                                        width: '550px',
                                                        maxWidth: '550px'
                                                    }
                                                },
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                },
                                                getContentAnchorEl: null
                                            }}
                                            sx={{ width: '100%' }}
                                        >
                                            {passageList && passageList?.length > 0 &&
                                                passageList.map((passage) => (
                                                    <MenuItem key={passage.id} value={passage}>
                                                        {passage.passage_text.length > 30 ? (
                                                            <Tooltip
                                                                title={
                                                                    <div
                                                                        dangerouslySetInnerHTML={{ __html: passage.passage_text }}
                                                                        style={{ maxWidth: 400 }}
                                                                    />
                                                                }
                                                                placement="top"
                                                                arrow
                                                            >
                                                                <ListItemText
                                                                    primary={
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: passage.passage_text }}
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                maxWidth: '512px'
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        ) : (
                                                            <ListItemText
                                                                primary={
                                                                    <div
                                                                        dangerouslySetInnerHTML={{ __html: passage.passage_text }}
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            maxWidth: '512px'
                                                                        }}
                                                                    />
                                                                }
                                                            />
                                                        )}

                                                    </MenuItem>
                                                ))}
                                        </Select>
                                        {passageError && (
                                            <div style={{ color: 'red', marginBottom: '2px', marginTop: '2px', fontSize: '12px' }}>
                                                {passageError}
                                            </div>
                                        )}
                                    </Grid>}


                                <Grid item xs={12}>
                                    <FormControl className={classes.formControl} error={touched.question && Boolean(errors.question)}>
                                        <Typography className={classes.background} gutterBottom variant="subtitle1">
                                            Create Question *
                                        </Typography>


                                        {values.questionType === 'Chemistry' || values.questionType === 'Physics' || values.questionType === 'Biology' ?
                                            <QuillEditor
                                                ref={quillRefs.question}
                                                defaultValue={values.question || ''}
                                                onChange={(value) => {
                                                    setFieldValue('question', value);
                                                }}
                                                theme="snow"
                                                id='questionTxt'
                                                name="question"
                                                modules={questionModules}
                                                formats={formats}
                                                onBlur={() => {
                                                    handleBlur({ target: { name: 'question' } });
                                                }}
                                                preserveWhitespace
                                                fullWidth
                                            />
                                            :
                                            <QuillEditor
                                                ref={quillRefs.question}
                                                defaultValue={values.question || ''}
                                                onChange={(value) => {
                                                    setFieldValue('question', value);
                                                }}

                                                theme="snow"
                                                id='questionTxt'
                                                name="question"
                                                modules={questionModules}
                                                formats={formats}
                                                onBlur={() => {
                                                    handleBlur({ target: { name: 'question' } });
                                                }}
                                                preserveWhitespace
                                                fullWidth
                                            />}
                                        {touched.question && errors.question && (
                                            <FormHelperText>{errors.question}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                {(values.questionType === "MCQ" || values.questionType === "JEEMCQ1" || values.questionType === "JEEMCQ2" || values.questionType === "JEEPassage" || values.questionType === "ClatPassage" || values.questionType === "screenLevelMcq") && (
                                    <>
                                        {/* <FieldArray name="mcqOptions">
                                        {({ insert, remove, push }) => (
                                            <Grid item xs={12}>
                                                {values.mcqOptions && values.mcqOptions.length > 0 &&
                                                    values.mcqOptions.map((opt, index) => (
                                                        <div style={{ position: 'relative', marginTop: '10px' }} key={index}>
                                                            <Grid container spacing={2} alignItems="center">
                                                                <Grid container spacing={2} alignItems="center">
                                                                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', marginLeft: 40 }}>
                                                                        <QuillEditor
                                                                            ref={quillRefs.mcqOptions.current[index]}
                                                                            theme="snow"
                                                                            id={`optiontext${index}`}
                                                                            name="mcqQuestion"
                                                                            value={opt.option}
                                                                            onChange={(value) => {
                                                                                setFieldValue(`mcqOptions.${index}.option`, value);
                                                                            }}
                                                                            // modules={modules}
                                                                            modules={mcqModulesArray[index]}

                                                                            formats={formats}
                                                                            placeholder="Option"
                                                                            style={{ marginTop: 10, flex: 1 }}
                                                                        />
                                                                        <IconButton
                                                                            aria-label="delete"
                                                                            id='cancelButton'
                                                                            color="error"
                                                                            onClick={() => remove(index)}
                                                                            style={{ marginLeft: '-8px', marginTop: '-8px' }}
                                                                        >
                                                                            <ClearIcon fontSize="small" />
                                                                        </IconButton>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    name={`mcqOptions.${index}.isCorrect`}
                                                                                    id='CurrectAnswer'
                                                                                    checked={opt.isCorrect}
                                                                                    onChange={() => {
                                                                                        if (opt.option.trim()) {
                                                                                            setFieldValue(`mcqOptions.${index}.isCorrect`, !opt.isCorrect);
                                                                                        }
                                                                                        setCurrectError('');
                                                                                    }}
                                                                                    disabled={!opt.option.trim()}
                                                                                />
                                                                            }
                                                                            label="Correct"
                                                                        />
                                                                    </Grid>
                                                                    {errors.mcqOptions?.[index]?.option && (
                                                                        <div className="error-text" style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                                            {errors.mcqOptions[index].option}
                                                                        </div>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    ))}
                                                {submitError && (
                                                    <div style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                        {submitError}
                                                    </div>
                                                )}
                                                {currectError && (
                                                    <div style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                        {currectError}
                                                    </div>
                                                )}

                                                <button
                                                    type="button"
                                                    id="addOptionButton"
                                                    style={{
                                                        width: '90%',
                                                        backgroundColor: 'rgb(63, 186, 150)',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        padding: '10px 20px',
                                                        margin: '10px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={async () => {
                                                        if (values.mcqOptions.every(option => option.option.trim())) {
                                                            await new Promise((resolve) =>
                                                                setTimeout(() => {
                                                                    push({ option: "", isCorrect: false });
                                                                    resolve();
                                                                }, 500)
                                                            );
                                                        }
                                                        setSubmitError('');
                                                    }}
                                                >
                                                    Add Option
                                                </button>
                                            </Grid>
                                        )}
                                    </FieldArray> */}

                                        <FieldArray name="mcqOptions">
                                            {({ insert, remove, push }) => (
                                                <Grid item xs={12}>
                                                    {values.mcqOptions && values.mcqOptions.length > 0 &&
                                                        values.mcqOptions.map((opt, index) => (
                                                            <div style={{ position: 'relative', marginTop: '10px' }} key={index}>
                                                                <Grid container spacing={2} alignItems="center">
                                                                    <Grid container spacing={2} alignItems="center">
                                                                        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', marginLeft: 40 }}>

                                                                            <QuillEditor
                                                                                ref={quillRefs.mcqOptions.current[index]}
                                                                                theme="snow"
                                                                                id={`optiontext${index}`}
                                                                                name="mcqQuestion"
                                                                                value={opt.option}
                                                                                onChange={(value) => {
                                                                                    setFieldValue(`mcqOptions.${index}.option`, value);
                                                                                }}
                                                                                modules={mcqModulesArray[index]}
                                                                                formats={formats}
                                                                                placeholder="Option"
                                                                                style={{ marginTop: 10, flex: 1 }}
                                                                            />

                                                                            <IconButton
                                                                                aria-label="delete"
                                                                                id="cancelButton"
                                                                                color="error"
                                                                                onClick={() => remove(index)}
                                                                                style={{ marginLeft: '-8px', marginTop: '-8px' }}
                                                                            >
                                                                                <ClearIcon fontSize="small" />
                                                                            </IconButton>

                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        name={`mcqOptions.${index}.isCorrect`}
                                                                                        id="CurrectAnswer"
                                                                                        checked={opt.isCorrect}
                                                                                        onChange={() => {
                                                                                            if (!opt.option.trim()) return;
                                                                                            if (values.questionType === "JEEMCQ2" || values.questionType === "JEEPassage" || values.questionType === "ClatPassage") {
                                                                                                setFieldValue(`mcqOptions.${index}.isCorrect`, !opt.isCorrect);
                                                                                            }
                                                                                            else {
                                                                                                const updatedOptions = values.mcqOptions.map((o, i) => ({
                                                                                                    ...o,
                                                                                                    isCorrect: i === index ? true : false,
                                                                                                }));
                                                                                                setFieldValue("mcqOptions", updatedOptions);
                                                                                            }

                                                                                            setCurrectError('');
                                                                                        }}
                                                                                        disabled={!opt.option.trim()}
                                                                                    />
                                                                                }
                                                                                label="Correct"
                                                                            />
                                                                        </Grid>

                                                                        {errors.mcqOptions?.[index]?.option && (
                                                                            <div
                                                                                className="error-text"
                                                                                style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}
                                                                            >
                                                                                {errors.mcqOptions[index].option}
                                                                            </div>
                                                                        )}
                                                                    </Grid>
                                                                </Grid>
                                                            </div>
                                                        ))}

                                                    {submitError && (
                                                        <div style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                            {submitError}
                                                        </div>
                                                    )}
                                                    {currectError && (
                                                        <div style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                            {currectError}
                                                        </div>
                                                    )}

                                                    <button
                                                        type="button"
                                                        id="addOptionButton"
                                                        style={{
                                                            width: '90%',
                                                            backgroundColor: 'rgb(63, 186, 150)',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            padding: '10px 20px',
                                                            margin: '10px',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={async () => {
                                                            if (values.mcqOptions.every(option => option.option.trim())) {
                                                                await new Promise((resolve) =>
                                                                    setTimeout(() => {
                                                                        push({ option: "", isCorrect: false });
                                                                        resolve();
                                                                    }, 500)
                                                                );
                                                            }
                                                            setSubmitError('');
                                                        }}
                                                    >
                                                        Add Option
                                                    </button>
                                                </Grid>
                                            )}
                                        </FieldArray>

                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} error={touched.question && Boolean(errors.question)}>
                                                <Typography className={classes.background} gutterBottom variant="subtitle1">
                                                    Add  Explanation*
                                                </Typography>
                                                {values.questionType === 'Chemistry' || values.questionType === 'Physics' || values.questionType === 'Biology' ?
                                                    <QuillEditor
                                                        ref={quillRefs.explanation}
                                                        defaultValue={values.explanation || ''}
                                                        onChange={(value) => {
                                                            setFieldValue('explanation', value);
                                                        }}
                                                        theme="snow"
                                                        id='questionTxt'
                                                        name="explanation"
                                                        modules={explanationModules}
                                                        formats={formats}
                                                        onBlur={() => {
                                                            handleBlur({ target: { name: 'question' } });
                                                        }}
                                                        fullWidth
                                                    />
                                                    :
                                                    <QuillEditor
                                                        ref={quillRefs.explanation}
                                                        defaultValue={values.explanation || ''}
                                                        onChange={(value) => {
                                                            setFieldValue('explanation', value);
                                                        }}
                                                        theme="snow"
                                                        id='questionTxt'
                                                        name="explanation"
                                                        modules={explanationModules}
                                                        formats={formats}
                                                        onBlur={() => {
                                                            handleBlur({ target: { name: 'question' } });
                                                        }}
                                                        fullWidth
                                                    />}
                                                {touched.explanation && errors.explanation && (
                                                    <FormHelperText>{errors.explanation}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    </>

                                )}
                                {(values.questionType === 'Chemistry' || values.questionType === 'Physics' || values.questionType === 'Biology') && (
                                    <>
                                        <FieldArray name="mcqOptions">
                                            {({ insert, remove, push }) => (
                                                <Grid item xs={12}>
                                                    {values.mcqOptions && values.mcqOptions.length > 0 &&
                                                        values.mcqOptions.map((opt, index) => (
                                                            <div style={{ position: 'relative', marginTop: '10px' }} key={index}>
                                                                <Grid container spacing={2} alignItems="center">
                                                                    <Grid container spacing={2} alignItems="center">
                                                                        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', marginLeft: 40 }}>
                                                                            <QuillEditor
                                                                                key={`mcq-option-${index}`}
                                                                                ref={quillRefs.mcqOptions.current[index]}
                                                                                theme="snow"
                                                                                id={`optiontext${index}`}
                                                                                name="mcqQuestion"
                                                                                value={opt.option}
                                                                                onChange={(value) => {
                                                                                    setFieldValue(`mcqOptions.${index}.option`, value);
                                                                                }}
                                                                                modules={mcqModulesArray[index]}
                                                                                formats={formats}
                                                                                placeholder="Option"
                                                                                style={{ marginTop: 10, flex: 1 }}
                                                                            />
                                                                            <IconButton
                                                                                aria-label="delete"
                                                                                id='cancelButton'
                                                                                color="error"
                                                                                onClick={() => remove(index)}
                                                                                style={{ marginLeft: '-8px', marginTop: '-8px' }}
                                                                            >
                                                                                <ClearIcon fontSize="small" />
                                                                            </IconButton>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        name={`mcqOptions.${index}.isCorrect`}
                                                                                        id='CurrectAnswer'
                                                                                        checked={opt.isCorrect}
                                                                                        onChange={() => {
                                                                                            if (opt.option.trim()) {
                                                                                                setFieldValue(`mcqOptions.${index}.isCorrect`, !opt.isCorrect);
                                                                                            }
                                                                                            setCurrectError('');
                                                                                        }}
                                                                                        disabled={!opt.option.trim()}
                                                                                    />
                                                                                }
                                                                                label="Correct"
                                                                            />
                                                                        </Grid>
                                                                        {errors.mcqOptions?.[index]?.option && (
                                                                            <div className="error-text" style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                                                {errors.mcqOptions[index].option}
                                                                            </div>
                                                                        )}
                                                                    </Grid>
                                                                </Grid>
                                                            </div>
                                                        ))}
                                                    {submitError && (
                                                        <div style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                            {submitError}
                                                        </div>
                                                    )}
                                                    {currectError && (
                                                        <div style={{ color: 'red', marginBottom: '10px', marginLeft: '100px', fontSize: '12px' }}>
                                                            {currectError}
                                                        </div>
                                                    )}

                                                    <button
                                                        type="button"
                                                        id="addOptionButton"
                                                        style={{
                                                            width: '90%',
                                                            backgroundColor: 'rgb(63, 186, 150)',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            padding: '10px 20px',
                                                            margin: '10px',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            if (values.mcqOptions.every(option => option.option.trim())) {
                                                                push({ option: "", isCorrect: false });
                                                            }
                                                            setSubmitError('');
                                                        }}
                                                    >
                                                        Add Option
                                                    </button>
                                                </Grid>
                                            )}
                                        </FieldArray>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} error={touched.question && Boolean(errors.question)}>
                                                <Typography className={classes.background} gutterBottom variant="subtitle1">
                                                    Add  Explanation*
                                                </Typography>
                                                <QuillEditor
                                                    ref={quillRefs.explanation}
                                                    defaultValue={values.explanation || ''}
                                                    onChange={(value) => {
                                                        setFieldValue('explanation', value);
                                                    }}
                                                    theme="snow"
                                                    id='questionTxt'
                                                    name="explanation"
                                                    modules={explanationModules}
                                                    formats={formats}
                                                    onBlur={() => {
                                                        handleBlur({ target: { name: 'question' } });
                                                    }}
                                                    fullWidth
                                                />
                                                {touched.explanation && errors.explanation && (
                                                    <FormHelperText>{errors.explanation}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    </>

                                )}

                                {values.questionType === 'JEENumeric' &&
                                    <>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} error={touched.question && Boolean(errors.question)}>
                                                <Typography className={classes.background} gutterBottom variant="subtitle1">
                                                    Numeric Answer *
                                                </Typography>
                                                {/* <TextField type='number' value={numericvalue} onChange={(e) => { setNumericAnswer(e.target.value); setNumericError('') }} /> */}
                                                <TextField
                                                    type="text"
                                                    value={numericvalue}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        const regex = /^[+-]?\d*(?:\.\d*)?$/;

                                                        if (regex.test(value)) {
                                                            setNumericAnswer(value);
                                                            setNumericError('');
                                                        }
                                                    }}
                                                    inputProps={{
                                                        inputMode: 'decimal',
                                                    }}
                                                />

                                            </FormControl>
                                            {numericError && (
                                                <div style={{ color: 'red', marginBottom: '2px', marginTop: '2px', fontSize: '12px' }}>
                                                    {numericError}
                                                </div>
                                            )}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} error={touched.question && Boolean(errors.question)}>
                                                <Typography className={classes.background} gutterBottom variant="subtitle1">
                                                    Add  Explanation*
                                                </Typography>
                                                <QuillEditor
                                                    ref={quillRefs.explanation}
                                                    defaultValue={values.explanation || ''}
                                                    onChange={(value) => {
                                                        setFieldValue('explanation', value);
                                                    }}
                                                    theme="snow"
                                                    id='questionTxt'
                                                    name="explanation"
                                                    modules={explanationModules}
                                                    formats={formats}
                                                    onBlur={() => {
                                                        handleBlur({ target: { name: 'question' } });
                                                    }}
                                                    fullWidth
                                                />
                                                {touched.explanation && errors.explanation && (
                                                    <FormHelperText style={{ color: 'red' }}>{errors.explanation}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    </>
                                }
                                {
                                    values.questionType === "IQ" && (
                                        <>
                                            <Grid item xs={12}>
                                                <Typography gutterBottom variant="subtitle1">
                                                    Key Type
                                                </Typography>
                                                <FormControl className={classes.formControl} error={touched.points && Boolean(errors.points)}>
                                                    <RadioGroup
                                                        id='keyType'
                                                        row
                                                        name="keyType"
                                                        value={values.keyType}
                                                        onChange={(e) => {
                                                            // setKeyType(e.target.value)
                                                            setFieldValue('keyType', e.target.value)
                                                        }}
                                                    >
                                                        <FormControlLabel value="INDIVIDUAL_HOT_KEYS" control={<Radio />} label="Individual Key" />
                                                        <FormControlLabel value="COMBINED_HOT_KEYS" control={<Radio />} label="Combined Keys" />
                                                    </RadioGroup>
                                                    {touched.keyType && errors.keyType && (
                                                        <FormHelperText style={{ color: '#FF4842' }} >{errors.keyType}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography align="left" gutterBottom sx={{ marginRight: '1.2rem !important' }}>
                                                    Enter Key
                                                </Typography>
                                                <Box display={'flex'} alignItems="center" justifyContent={'space-around'}>
                                                    <div className={classes.iconPosition}>
                                                        <img src={WindowsIcon} alt="icon" />
                                                    </div>
                                                    <Box textAlign="center" paddingTop="8px">
                                                        <TextField
                                                            sx={{ width: '100px' }}
                                                            id="outlined-basic"
                                                            autoComplete="off"
                                                            variant="outlined"
                                                            name="windowsKey"
                                                            onBlur={handleBlur}
                                                            onChange={(event) => console.log(event)}
                                                            onKeyDown={(e) => {
                                                                e.preventDefault();
                                                                console.log(e);
                                                                if (values.keyType === 'INDIVIDUAL_HOT_KEYS') {
                                                                    const wKeyCode = [];
                                                                    const wKeyNames = [];
                                                                    const windowsToMacKeyMap = {
                                                                        'Control': 'Command',
                                                                        'Alt': 'Option',
                                                                        'Enter': 'Return',
                                                                        'Backspace': 'Delete',
                                                                    };
                                                                    wKeyCode.push(e.keyCode);
                                                                    wKeyNames.push(e.keyCode === 32 ? 'space' : e.key);

                                                                    const macKeyNameArray = wKeyNames.map(key => windowsToMacKeyMap[key] || key);

                                                                    setCombinedWKeyName(wKeyNames);
                                                                    setCombinedMKeyName(macKeyNameArray);
                                                                    setFieldValue('windowsKey', e.key);
                                                                    setFieldValue('macKey', e.key);
                                                                    setFieldValue('combinedWindowKeys', wKeyCode);
                                                                    setFieldValue('combinedWindowKeyName', wKeyNames);
                                                                    setFieldValue('combinedMacKeyName', macKeyNameArray);
                                                                    setFieldValue('combinedMacKeys', wKeyCode);
                                                                    setFieldValue('windowsKey', e.keyCode === 32 ? 'space' : e.key);
                                                                    setFieldValue('macKey', e.keyCode === 32 ? 'space' : windowsToMacKeyMap[e.key] || e.key);
                                                                } else {
                                                                    const keyCodeArray = combinedWKeys;
                                                                    const keyNameArray = combinedWKeyName;
                                                                    if (keyCodeArray.length > 3) {
                                                                        // setOpenSnackbar(true);
                                                                        // setSnackbarTitle('Maximum keys are 4');
                                                                        return false;
                                                                    }
                                                                    const windowsToMacKeyMap = {
                                                                        'Control': 'Command',
                                                                        'Alt': 'Option',
                                                                        'Enter': 'Return',
                                                                        'Backspace': 'Delete',
                                                                    };

                                                                    keyNameArray.push(e.keyCode === 32 ? 'space' : e.key);
                                                                    keyCodeArray.push(e.keyCode.toString());

                                                                    // Convert Windows keys to Mac keys
                                                                    const macKeyNameArray = keyNameArray.map(key => windowsToMacKeyMap[key] || key);

                                                                    setCombinedWKeys(keyCodeArray);
                                                                    setCombinedWKeyName(keyNameArray);
                                                                    setCombinedMKeys(keyCodeArray);
                                                                    setCombinedMKeyName(macKeyNameArray);

                                                                    setFieldValue('combinedWindowKeys', combinedWKeys);
                                                                    setFieldValue('combinedMacKeys', combinedMKeys);
                                                                    setFieldValue('combinedWindowKeyName', combinedWKeyName);
                                                                    setFieldValue('combinedMacKeyName', macKeyNameArray);
                                                                    setFieldValue('windowsKey', e.keyCode === 32 ? 'space' : e.key);
                                                                    setFieldValue('macKey', e.keyCode === 32 ? 'space' : windowsToMacKeyMap[e.key] || e.key);
                                                                }
                                                            }}
                                                            type="text"
                                                            value={values.windowsKey}
                                                            error={Boolean(touched.windowsKey && errors.windowsKey)}
                                                            helperText={touched.windowsKey && errors.windowsKey}
                                                        />
                                                        <ErrorFocus />
                                                    </Box>
                                                </Box>
                                                <Box marginTop={1}>
                                                    {useWindowVirtualKeys ? (
                                                        <Autocomplete
                                                            options={widowKeys}
                                                            autoHighlight
                                                            sx={{
                                                                '.MuiOutlinedInput-input': {
                                                                    padding: '0px 6px !important',
                                                                },
                                                            }}
                                                            filterSelectedOptions
                                                            getOptionLabel={(option) => option.description || ''}
                                                            value={values.hashtag}
                                                            onChange={(e, value) => {
                                                                if (value) {
                                                                    if (values.keyType === 'INDIVIDUAL_HOT_KEYS') {
                                                                        const wKeyCode = [];
                                                                        const wKeyNames = [];
                                                                        wKeyCode.push(value.code);
                                                                        wKeyNames.push(value.description);
                                                                        setCombinedWKeyName(wKeyNames);
                                                                        setFieldValue('combinedWindowKeys', wKeyCode);
                                                                        setFieldValue('combinedWindowKeyName', wKeyNames);
                                                                        setFieldValue('windowsKey', value.description);
                                                                        setUseWindowVirtualKeys(false);
                                                                    } else {
                                                                        const keyCodeArray = combinedWKeys;
                                                                        const keyNameArray = combinedWKeyName;
                                                                        keyNameArray.push(value.description);
                                                                        keyCodeArray.push(value.code);
                                                                        setCombinedWKeys(keyCodeArray);
                                                                        setCombinedWKeyName(keyNameArray);
                                                                        setFieldValue('combinedWindowKeys', combinedWKeys);
                                                                        setFieldValue('combinedWindowKeyName', combinedWKeyName);
                                                                        setFieldValue('windowsKey', value.description);
                                                                        setUseWindowVirtualKeys(false);
                                                                    }
                                                                }
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    placeholder="select key"
                                                                    {...params}
                                                                    variant="outlined"
                                                                    name="hashtag"
                                                                    fullWidth
                                                                />
                                                            )}
                                                        />
                                                    ) : (
                                                        // <Typography variant="body2" align="center" sx={{ cursor: 'pointer' }}>
                                                        //   If you don't find the relevant keys on your keyboard{' '}
                                                        <Tooltip arrow title=" If you don't find the relevant keys on your keyboard? Click on Keys">
                                                            <Link
                                                                onClick={() => setUseWindowVirtualKeys(true)}
                                                                sx={{ textDecoration: 'none', cursor: 'pointer', fontSize: '0.7rem' }}
                                                            >
                                                                Find keys
                                                            </Link>
                                                        </Tooltip>
                                                        // </Typography>
                                                    )}
                                                </Box>

                                                <Box display={'flex'} marginTop={1}>
                                                    {combinedWKeyName.map((res, i) => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography className={classes.boxItem}>{res}</Typography>
                                                            {i < combinedWKeyName.length - 1 && (
                                                                <Typography variant="h6" sx={{ margin: '4px !important' }}>
                                                                    +
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    ))}
                                                </Box>
                                                {combinedWKeyName.length > 0 && (
                                                    <Typography
                                                        sx={{
                                                            marginTop: '8px !important',
                                                            cursor: 'pointer',
                                                            width: 'max-content',
                                                            fontSize: '0.7rem',
                                                        }}
                                                        color="primary"
                                                        onClick={() => {
                                                            setFieldValue('windowsKey', '');
                                                            setCombinedWKeyName([]);
                                                            setCombinedWKeys([]);
                                                            setCombinedMKeys([]);
                                                        }}
                                                    >
                                                        Clear
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography align="left" gutterBottom sx={{ marginRight: '1.2rem !important' }}>
                                                    Enter Key
                                                </Typography>
                                                <Box display={'flex'} alignItems="center" justifyContent={'space-around'}>
                                                    <div className={classes.iconPosition}>
                                                        <AppleIcon
                                                            color="#a0a8ae"
                                                            sx={{ width: '60px !important', height: '55px !important', color: '#a0a8ae' }}
                                                        />
                                                    </div>
                                                    <Box textAlign="center" >
                                                        <TextField
                                                            sx={{ width: '100px' }}
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            autoComplete="off"
                                                            name="macKey"
                                                            onBlur={handleBlur}
                                                            onKeyDown={(e) => {
                                                                e.preventDefault();
                                                                if (values.keyType === 'INDIVIDUAL_HOT_KEYS') {
                                                                    const mKeyCode = [];
                                                                    const mKeyNames = [];
                                                                    mKeyCode.push(e.keyCode);
                                                                    if (e.keyCode === 91 || e.keyCode === 93) {
                                                                        mKeyNames.push('command');
                                                                    } else {
                                                                        mKeyNames.push(e.keyCode === 32 ? 'space' : e.key);
                                                                    }

                                                                    setCombinedMKeyName(mKeyNames);
                                                                    setFieldValue('combinedMacKeyName', mKeyNames);
                                                                    setFieldValue('combinedMacKeys', mKeyCode);
                                                                    if (e.keyCode === 91 || e.keyCode === 93) {
                                                                        setFieldValue('macKey', 'command');
                                                                    } else {
                                                                        setFieldValue('macKey', e.keyCode === 32 ? 'space' : e.key);
                                                                    }
                                                                } else {
                                                                    const macKeyCode = combinedMKeys;
                                                                    const macKeyName = combinedMKeyName;
                                                                    if (macKeyCode.length > 3) {
                                                                        // setOpenSnackbar(true);
                                                                        // setSnackbarTitle('Maximum keys are 4');
                                                                        return false;
                                                                    }
                                                                    if (e.keyCode === 91 || e.keyCode === 93) {
                                                                        macKeyName.push('command');
                                                                    } else {
                                                                        macKeyName.push(e.keyCode === 32 ? 'space' : e.key);
                                                                    }

                                                                    macKeyCode.push(e.keyCode.toString());
                                                                    setCombinedMKeys(macKeyCode);
                                                                    setCombinedMKeyName(macKeyName);
                                                                    setFieldValue('combinedMacKeys', combinedMKeys);
                                                                    setFieldValue('combinedMacKeyName', combinedMKeyName);

                                                                    if (e.keyCode === 91 || e.keyCode === 93) {
                                                                        setFieldValue('macKey', 'command');
                                                                    } else {
                                                                        setFieldValue('macKey', e.keyCode === 32 ? 'space' : e.key);
                                                                    }
                                                                }
                                                            }}
                                                            type="text"
                                                            value={values.macKey}
                                                            error={Boolean(touched.macKey && errors.macKey)}
                                                            helperText={touched.macKey && errors.macKey}
                                                        />
                                                        <ErrorFocus />
                                                    </Box>
                                                </Box>
                                                <Box marginTop={1}>
                                                    {useMacVirtualKeys ? (
                                                        <Autocomplete
                                                            options={macKeys}
                                                            autoHighlight
                                                            sx={{
                                                                '.MuiOutlinedInput-input': {
                                                                    padding: '0px 6px !important',
                                                                },
                                                            }}
                                                            filterSelectedOptions
                                                            getOptionLabel={(option) => option.description || ''}
                                                            value={values.hashtag}
                                                            onChange={(e, value) => {
                                                                if (value) {
                                                                    console.log(value);
                                                                    if (values.keyType === 'INDIVIDUAL_HOT_KEYS') {
                                                                        const mKeyCode = [];
                                                                        const mKeyNames = [];
                                                                        mKeyCode.push(value.code);
                                                                        mKeyNames.push(value.description);
                                                                        setCombinedMKeyName(mKeyNames);
                                                                        setFieldValue('combinedMacKeys', mKeyCode);
                                                                        setFieldValue('combinedMacKeyName', mKeyNames);
                                                                        setFieldValue('macKey', value.description);
                                                                        setUseMacVirtualKeys(false);
                                                                    } else {
                                                                        const keyCodeArray = combinedMKeys;
                                                                        const keyNameArray = combinedMKeyName;
                                                                        keyNameArray.push(value.description);
                                                                        keyCodeArray.push(value.code);
                                                                        setCombinedMKeys(keyCodeArray);
                                                                        setCombinedMKeyName(keyNameArray);
                                                                        setFieldValue('combinedMacKeys', combinedMKeys);
                                                                        setFieldValue('combinedMacKeyName', combinedMKeyName);
                                                                        setFieldValue('macKey', value.description);
                                                                        setUseMacVirtualKeys(false);
                                                                    }
                                                                }
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    placeholder="select key"
                                                                    {...params}
                                                                    variant="outlined"
                                                                    name="hashtag"
                                                                    fullWidth
                                                                />
                                                            )}
                                                        />
                                                    ) : (
                                                        <Tooltip arrow title=" If you don't find the relevant keys on your keyboard? Click on Keys">
                                                            <Link
                                                                onClick={() => setUseMacVirtualKeys(true)}
                                                                sx={{ textDecoration: 'none', cursor: 'pointer', fontSize: '0.7rem' }}
                                                            >
                                                                Find keys
                                                            </Link>
                                                        </Tooltip>
                                                    )}
                                                </Box>

                                                <Box display={'flex'} marginTop={1}>
                                                    {combinedMKeyName.map((res, i) => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography className={classes.boxItem}>{res}</Typography>
                                                            {i < combinedMKeyName.length - 1 && (
                                                                <Typography variant="h5" sx={{ margin: '4px !important' }}>
                                                                    +
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    ))}
                                                </Box>
                                                {combinedMKeyName.length > 0 && (
                                                    <Typography
                                                        sx={{
                                                            marginTop: '8px !important',
                                                            cursor: 'pointer',
                                                            width: 'max-content',
                                                            fontSize: '0.7rem',
                                                        }}
                                                        color="primary"
                                                        onClick={() => {
                                                            setFieldValue('macKey', '');
                                                            setCombinedMKeyName([]);
                                                            setCombinedMKeys([]);
                                                        }}
                                                    >
                                                        Clear
                                                    </Typography>
                                                )}

                                            </Grid>
                                        </>
                                    )}


                                <Grid item xs={12}>
                                    <LoadingButton
                                        id="subMitButton"
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        loading={loading}
                                        fullWidth
                                    >
                                        Submit
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </Form>
                    )
                }}
            </Formik>
        </DialogModal>
    );
};

export default CreateMcqQuestionModel;
